/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { Base64 } from 'js-base64'
import * as Yup from 'yup'
import { FiUser, FiSmartphone, FiMail } from 'react-icons/fi'
import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import api from '../../services/api'
import InputHidden from '../../components/InputHidden'
import Button from '../../components/Button'
import Header from '../../components/Header'
import Input from '../../components/Input'
import {
  Container,
  RadioButton,
  BtnContato,
  Content,
  BtnModal,
  BtnVoltar,
} from './styles'
import { UserData, ConfigData, ErroProps } from '../../utils/interfaces'
import ModalBox from '../../components/Modal'
import { MdSecurity } from 'react-icons/md'
import validaCPF from '../../utils/validaCPF'
import { useLeadLovers } from '../../hooks/mectrics'

const Register: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )
  const [tipoContato, setTipoContato] = useState('S')
  const [clicado, setClicado] = useState(false)
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal, setTxtModal] = useState('')

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          name: Yup.string()
            .required('Seu nome é obrigatório.')
            .matches(/\s/g, 'Digite o nome completo')
            .min(5, 'Digite o nome completo'),
          cpf: Yup.string()
            .required('CPF obrigatório')
            .test(
              '',
              'CPF inválido',
              () =>
                validaCPF(data.cpf.replaceAll('.', '').replace('-', '')) ||
                data.cpf === '',
            ),
          tipContato: Yup.string().required(),
          email: Yup.string()
            .required('E-mail pessoal é obrigatório')
            .email('Digite um e-mail válido'),
          phone: Yup.string()
            .max(15, 'Telefone inválido')
            .min(14, 'Telefone inválido')
            .required('Celular é obrigatório'),
        })

        await schema.validate(data, { abortEarly: false })

        setClicado(true)

        setUserData({
          ...userData,
          name: data.name,
          email: data.email,
          phone: data.phone,
          cpf: data.cpf,
        })

        const parametros = Base64.encode(
          `{"versao":"${configData.tipo}",
            "plano": "${configData.plano}",
            "cliente":"${configData.codCliente}",
            "cpf":"${data.cpf.replaceAll('.', '').replace('-', '')}",
            "email":"${data.email === undefined ? '' : data.email}",
            "telefone":"${
              data.phone === undefined
                ? ''
                : `55${data.phone
                    .replace('(', '')
                    .replace(') ', '')
                    .replace('-', '')}`
            }",
            "admissao":"",
            "envio":"${tipoContato}"}`,
        )

        const parametrosFinal = Base64.encode(parametros)
        // history.push('/register/confirm-sms')
        await api
          .get(`wsAutenticacao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
          .then(res => {
            setConfigData({ ...configData, token: res.data.token, tipoContato })
            history.push('/register/confirm-sms')
          })
          .catch(res => {
            if (res.message === 'Network Error') {
              setErroProps({
                title: res.message,
                description: 'Falha na conexão como servidor',
              })
              setClicado(false)
              history.push('/erro')
            } else if (res.message === 'Request failed with status code 500') {
              setErroProps({
                title: 'Erro interno no servidor',
                description: res.message,
              })
              setClicado(false)
              history.push('/erro')
            } else if (res.message === 'Request failed with status code 401') {
              setIsModalOpen(true)
              setTxtModal('Ops, algo deu errado. Tente novamente mais tarde.')
              setClicado(false)
            } else if (res.message === 'Request failed with status code 408') {
              alert('Tempo de sessão expirado')
            } else if (res.message === 'Request failed with status code 404') {
              setIsModalOpen(true)
              setTxtModal('Não localizamos seu cpf na base de dados. Por favor entre em contato com o Cibrius.')
              setClicado(false)
            } else if (res.message === 'Request failed with status code 406') {
              setIsModalOpen(true)
              setTxtModal('CPF já inscrito no plano. Para mais informações entre em contato com o Cibrius.')
              setClicado(false)
            } else if (res.message === 'Request failed with status code 417') {
              setIsModalOpen(true)
              setTxtModal('Não foi possível enviar SMS. Verifique o telefone informado.')
              setClicado(false)
            } else {
              setIsModalOpen(true)
              setTxtModal('Ops, algo deu errado. Tente novamente mais tarde.')
              setClicado(false)
            }
          })
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err as any))
      }
    },
    [
      configData,
      history,
      setConfigData,
      setErroProps,
      setUserData,
      tipoContato,
      userData,
    ],
  )

  const handleConfirmar = useCallback(event => {
    event.preventDefault()
    formRef.current?.submitForm()
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Informe os dados cadastrais para prosseguir</strong>
          <Form ref={formRef} onSubmit={handleSubmit} initialData={userData}>
            <Input name="name" placeholder="Nome Completo" icon={FiUser} />
            <Input placeholder="Digite seu CPF" name="cpf" icon={MdSecurity} type="tel" mask="cpf" maxLength={11} />
            <Input
              name="phone"
              mask="phone"
              prefix="+55 | "
              placeholder="Celular com DDD"
              icon={FiSmartphone}
            />
            <Input
              icon={FiMail}
              name="email"
              id="email"
              type="text"
              placeholder="E-mail"
              maxLength={150}
            />
            <RadioButton>
              <label>Enviar código de confirmação por: </label>
              <div>
                <BtnContato
                  type="button"
                  isActive={tipoContato === 'S'}
                  onClick={() => setTipoContato('S')}
                >
                  SMS
                </BtnContato>
                <BtnContato
                  type="button"
                  isActive={tipoContato === 'E'}
                  onClick={() => setTipoContato('E')}
                >
                  E-mail
                </BtnContato>
              </div>
            </RadioButton>
            <InputHidden name="tipContato" value={tipoContato} type="hidden" />
          </Form>
        </Content>

        <Button
          type="submit"
          color="blue"
          onClick={handleConfirmar}
          disabled={clicado}
        >
          Confirmar
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/simulation')}>
          &lt; Anterior
        </BtnVoltar>
        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Register
